import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SeoService } from '../../core/seo/seo.service';
import { PropertyDataProvider } from '../../core/data/property-data.provider';
import { PageHeaderComponent } from '../../shared/ui.components';

@Component({
  selector: 'app-methodology-page',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PageHeaderComponent],
  templateUrl: './methodology.page.html',
  styleUrl: './methodology.page.scss',
})
export class MethodologyPage {
  private readonly data = inject(PropertyDataProvider);
  private readonly meta = toSignal(this.data.meta());

  /**
   * Coverage stated by the data itself rather than by this page's prose.
   *
   * The page previously described a generated dataset long after the app had
   * started serving real one — the two drifted because both were written by
   * hand. Reading the month axis from /api/meta means the most load-bearing
   * claim here cannot go stale on its own.
   */
  readonly dataNote = computed(() => {
    const m = this.meta();
    if (!m) return null;
    const months = m.months;
    if (months.length === 0) return null;
    const cities = m.cities.length;
    const hoods = m.cities.reduce((n, c) => n + c.neighborhoods.length, 0);
    const span =
      months.length === 1
        ? `снимка за ${months[0]}`
        : `${months.length} месечни снимки, ${months[0]} – ${months[months.length - 1]}`;
    return `Обхванати: ${cities} града, ${hoods} квартала — ${span}.`;
  });

  constructor(seo: SeoService) {
    seo.set({
      title: 'Методология и Източници на данните за имоти — Имотомер',
      description: 'Формулите и източниците зад Имотомер: медиани €/м², официални сделки от Агенция по вписванията, доходност, достъпност, хедоничен модел и индекс на прегряване.',
      path: '/metodologia',
      keywords: [
        'методология имоти',
        'източници данни имоти',
        'статистика имоти формула',
        'агенция по вписванията данни',
        'имотомер',
        'imotomer',
      ],
      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Начало', item: 'https://real-estate.tur92.com/' },
          { '@type': 'ListItem', position: 2, name: 'Методология', item: 'https://real-estate.tur92.com/metodologia' },
        ],
      },
    });
  }
}
